// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"9ccede5c","85":"4338186a","152":"d6b06cd7","635":"233101ea"}[chunkId] + ".chunk.js";
};